// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"e4c8c285","453":"108a9891"}[chunkId] + ".chunk.js";
};